import { createRouter, createWebHistory } from 'vue-router';
import AdminPanel from '../views/AdminPanel.vue';
import ReservationCalendar from '../views/ReservationCalendar.vue';
import ClientView from '../views/ClientView.vue';
import AdminLogin from '../views/AdminLogin.vue';
import AcceptTerms from '../views/AcceptTerms.vue';
import ReservationHistoryView from '../views/ReservationHistoryView.vue'; // Nombre corregido
import ValetParkingView from '../views/ValetParkingView.vue'; // Importa la vista de Valet Parking
import SendSms from '../views/SendSms.vue'; // Importa la vista de SendSms

const routes = [
    { path: '/login', component: AdminLogin },
    {
        path: '/admin',
        component: AdminPanel,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/calendar',
        component: ReservationCalendar,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/history',
        component: ReservationHistoryView, // Nombre corregido
        meta: { requiresAuth: true }
    },
    { path: '/', component: ClientView },
    { path: '/accept-terms', component: AcceptTerms },
    { path: '/valet-parking', component: ValetParkingView }, // Ruta para Valet Parking
    {
        path: '/send-sms', // Ruta para SendSms
        component: SendSms,
        meta: { requiresAuth: true } // Protege la ruta si es necesario
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = !!localStorage.getItem('auth');  // Ajuste temporal para autenticación
    if (requiresAuth && !isAuthenticated) {
        next('/login');
    } else {
        next();
    }
});

export default router;
